import { closeModal } from "./syf-empq";

const isEventSourceSYF = (eventSource) => {
  let allowedDomains = ["syf.com", "mysynchrony.com", "syfpos.com", "syfpayments.com"];
  for (let i = 0; i < allowedDomains.length; i++) {
    if (eventSource.includes(allowedDomains[i])) {
      return true;
    }
  }
  return false;
}

const commonEventListener = (event) => {
  if (isEventSourceSYF(event.origin)) {
    if (typeof event.data == "object") {
      if (event.data.action !== undefined) {
        if (event.data.action === "applyCloseModal") {
          closeModal();
        }
      }

      if (event.data.event === "return-to-partner") {
        closeModal();
        console.log("return-button clicked " + event.data.event);
      }

      if (event.data.event === "return-to-source") {
        closeModal();
        console.log("return-source clicked " + event.data.event);
      }
    }
  }
};
export const registerSyfEventListener = () => {
  window.addEventListener("message", commonEventListener, false);
}
export const unregisterSyfEventListener = () => {
  window.removeEventListener("message", commonEventListener, false);
}
